import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    roles: null,
    user_id: null,
    accessToken: null,
    org_control_access: null,
  },
  reducers: {
    signIn: (state, action) => {
      const { roles, user_id, access, agreed_policies, org_control_access } =
        action.payload;
      state.roles = roles;
      state.user_id = user_id;
      state.accessToken = access;
      state.org_control_access = org_control_access;
      state.agreed_policies = agreed_policies;
    },
    signOut: (state) => {
      state.roles = null;
      state.user_id = null;
      state.accessToken = null;
      state.org_control_access = null;
    },
  },
});

export const { signIn, signOut } = authSlice.actions;

export default authSlice.reducer;
